import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import {
  faBell,
  faCalendar,
  faMessage,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHomeMobileTopBar } from "./homeMobileTopBar/useHomeMobileTopBar";

export function HomeMobileTopBar() {
  const {
    onClickCalendar,
    onClickNotifications,
    hasNewNotification,
    onClickMessages,
  } = useHomeMobileTopBar();

  return (
    <TopBarMobile
      header="home"
      rightSide={
        <div className="flex flex-row gap-8">
          <button onClick={onClickMessages}>
            <FontAwesomeIcon
              icon={faMessage}
              className="text-font-white text-2xl"
            />
          </button>
          <button onClick={onClickNotifications} className="relative">
            <FontAwesomeIcon
              icon={faBell}
              className="text-font-white text-2xl"
            />
            {/* NEW NOTIFICATION DOT */}
            {hasNewNotification && (
              <div
                className="
                absolute
                right-0
                bottom-0
                size-4
                outline
                outline-primary
                border-2
                border-font-white
                rounded-full
                bg-primary
              "
              />
            )}
          </button>
          <button onClick={onClickCalendar}>
            <FontAwesomeIcon
              icon={faCalendar}
              className="text-font-white text-2xl"
            />
          </button>
        </div>
      }
    />
  );
}
